/** Categories and snippets for the LaTeX insert palette (insert strings include $ where needed). */
export const LATEX_PALETTE = [
  {
    id: 'greek',
    label: 'Greek',
    items: [
      { label: 'α', insert: '$\\alpha$' },
      { label: 'β', insert: '$\\beta$' },
      { label: 'γ', insert: '$\\gamma$' },
      { label: 'δ', insert: '$\\delta$' },
      { label: 'ε', insert: '$\\varepsilon$' },
      { label: 'θ', insert: '$\\theta$' },
      { label: 'λ', insert: '$\\lambda$' },
      { label: 'μ', insert: '$\\mu$' },
      { label: 'π', insert: '$\\pi$' },
      { label: 'σ', insert: '$\\sigma$' },
      { label: 'φ', insert: '$\\phi$' },
      { label: 'ω', insert: '$\\omega$' },
      { label: 'Ω', insert: '$\\Omega$' },
      { label: 'Σ', insert: '$\\Sigma$' },
      { label: 'Δ', insert: '$\\Delta$' },
    ],
  },
  {
    id: 'operators',
    label: 'Operators',
    items: [
      { label: '·', insert: '$\\cdot$' },
      { label: '×', insert: '$\\times$' },
      { label: '÷', insert: '$\\div$' },
      { label: '±', insert: '$\\pm$' },
      { label: '∑', insert: '$\\sum$' },
      { label: '∏', insert: '$\\prod$' },
      { label: '∫', insert: '$\\int$' },
      { label: '∂', insert: '$\\partial$' },
      { label: '∞', insert: '$\\infty$' },
      { label: 'lim', insert: '$\\lim$' },
    ],
  },
  {
    id: 'relations',
    label: 'Relations',
    items: [
      { label: '≤', insert: '$\\leq$' },
      { label: '≥', insert: '$\\geq$' },
      { label: '≠', insert: '$\\neq$' },
      { label: '≈', insert: '$\\approx$' },
      { label: '≡', insert: '$\\equiv$' },
      { label: '∝', insert: '$\\propto$' },
      { label: '≪', insert: '$\\ll$' },
      { label: '≫', insert: '$\\gg$' },
      { label: '∼', insert: '$\\sim$' },
    ],
  },
  {
    id: 'arrows',
    label: 'Arrows',
    items: [
      { label: '→', insert: '$\\rightarrow$' },
      { label: '←', insert: '$\\leftarrow$' },
      { label: '↔', insert: '$\\leftrightarrow$' },
      { label: '⇒', insert: '$\\Rightarrow$' },
      { label: '⇐', insert: '$\\Leftarrow$' },
      { label: '⇔', insert: '$\\Leftrightarrow$' },
      { label: '↑', insert: '$\\uparrow$' },
      { label: '↓', insert: '$\\downarrow$' },
    ],
  },
  {
    id: 'sets',
    label: 'Sets & logic',
    items: [
      { label: '∈', insert: '$\\in$' },
      { label: '∉', insert: '$\\notin$' },
      { label: '⊂', insert: '$\\subset$' },
      { label: '∪', insert: '$\\cup$' },
      { label: '∩', insert: '$\\cap$' },
      { label: '∅', insert: '$\\emptyset$' },
      { label: '∀', insert: '$\\forall$' },
      { label: '∃', insert: '$\\exists$' },
      { label: '¬', insert: '$\\neg$' },
      { label: '∧', insert: '$\\land$' },
      { label: '∨', insert: '$\\lor$' },
    ],
  },
  {
    id: 'templates',
    label: 'Templates',
    items: [
      { label: 'a/b', insert: '$\\frac{}{}$' },
      { label: 'xⁿ', insert: '$^{}$' },
      { label: 'xₙ', insert: '$_{}$' },
      { label: '√', insert: '$\\sqrt{}$' },
      { label: 'Display', insert: '$$\n\n$$', cursorOffset: 2 },
    ],
  },
];
